import { KeyValue } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { WidgetBaseFilterModel } from '@clean-code/models';
import { ID } from '@clean-code/models/common';
import { GraphqlService } from '@clean-code/shared/util-graphql';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CustomersContractVolumeService {
  private graphqlService = inject(GraphqlService);

  public dashboardCustomersContractVolume$(
    value: WidgetBaseFilterModel,
  ): Observable<
    KeyValue<
      string,
      { volume: number; closed: number; companyId: ID; open: number }
    >[]
  > {
    const query = `
      query($input: WidgetBaseFilterInput!) {
        dashboardCustomersContractVolume(input: $input)
            {
                key
                value {
                  volume
                  open
                  closed
                  companyId
                }
              }
          }`;

    return this.graphqlService.query<
      KeyValue<
        string,
        { volume: number; closed: number; companyId: ID; open: number }
      >[]
    >(query, {
      input: value,
    });
  }
}
